"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var texts_1 = __importDefault(require("../../../common/src/constrains/locale/texts"));
var SimpleDialog = /** @class */ (function (_super) {
    __extends(SimpleDialog, _super);
    function SimpleDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleDialog.prototype.okClick = function (event) {
        event.preventDefault();
        this.$emit('ok-click');
    };
    SimpleDialog.prototype.cancelClick = function (event) {
        event.preventDefault();
        this.$emit('cancel-click');
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], SimpleDialog.prototype, "showDialog", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], SimpleDialog.prototype, "defaultMsg", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '600' })
    ], SimpleDialog.prototype, "maxWidth", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: true })
    ], SimpleDialog.prototype, "isConfirm", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: texts_1.default.ja.dictionary.button_caption.ok })
    ], SimpleDialog.prototype, "okButtonCaption", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: texts_1.default.ja.dictionary.button_caption.cancel })
    ], SimpleDialog.prototype, "cancelButtonCaption", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: true })
    ], SimpleDialog.prototype, "isHtml", void 0);
    SimpleDialog = __decorate([
        vue_property_decorator_1.Component
    ], SimpleDialog);
    return SimpleDialog;
}(vue_property_decorator_1.Vue));
exports.default = SimpleDialog;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/globals/SimpleDialog.vue
// module id = jje7
// module chunks = 1